import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import strftime from 'strftime';
import styles from './local-date.scss.js';
/**
 * cipublic-local-date
 */
export class LocalDate extends CipublicElement {
    get formatted() {
        return strftime(this.format);
    }
    render() {
        return html `<time datetime="${this.formatted}">${this.formatted}</time>`;
    }
}
LocalDate.styles = styles;
__decorate([
    property({ reflect: true })
], LocalDate.prototype, "format", void 0);
//# sourceMappingURL=local-date.js.map